var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"columns is-multiline"},[_c('div',{staticClass:"column is-full-mobile is-6"},[_c('basic')],1),_c('div',{staticClass:"column is-full-mobile is-6"},[_c('events')],1),_c('div',{staticClass:"column is-full-mobile is-6"},[_c('geo-chart')],1),_c('div',{staticClass:"column is-full-mobile is-6"},[_c('sets')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }